import React, { useEffect, useState, useRef } from "react";
import { Link, NavLink, useNavigate, useLocation } from "react-router-dom";
import Badge from "@mui/material/Badge";
import Menu from "@mui/material/Menu";
import Button from "react-bootstrap/Button";
import Table from "react-bootstrap/Table";
import { useDispatch, useSelector } from "react-redux";
import { DLT } from "../redux/actions/action";
import axios from "axios";
import { BASE_URL } from "../Config";
import { loginCustomer } from "../redux/actions/customerActions";
import Swal from "sweetalert2";
import { Offcanvas } from "bootstrap";

function Navbar() {
  const location = useLocation();
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const cartItems = useSelector((state) => state.cartreducer.carts);

  const [categories, setCategories] = useState([]);
  const [price, setPrice] = useState(0);
  const [anchorEl, setAnchorEl] = useState(null);
  const [showModal, setShowModal] = useState(false);
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [message, setMessage] = useState("");
  const [user, setUser] = useState(() => {
    return localStorage.getItem("webuser")
      ? JSON.parse(localStorage.getItem("webuser"))
      : null;
  });
  const [dropdownOpen, setDropdownOpen] = useState(false);

  const offcanvasRef = useRef();

  const openOffcanvas = () => {
    const offcanvas = new Offcanvas(offcanvasRef.current);
    offcanvas.show();
  };

  const closeOffcanvas = () => {
    const offcanvas = Offcanvas.getInstance(offcanvasRef.current);
    offcanvas.hide();
  };

  // Fetch categories
  useEffect(() => {
    const fetchCategories = async () => {
      try {
        const response = await axios.get(`${BASE_URL}/api/category_menu`);
        const categoryData = response.data.list;
        const structuredCategories = buildCategoryHierarchy(categoryData);
        setCategories(structuredCategories);
      } catch (error) {
        console.error("Error fetching categories:", error);
      }
    };
    fetchCategories();
  }, []);

  const buildCategoryHierarchy = (categoryData) => {
    const categoryMap = {};
    categoryData.forEach((cat) => {
      categoryMap[cat.id] = { ...cat, subcategories: [] };
    });
    const structuredCategories = [];
    categoryData.forEach((cat) => {
      if (cat.parent_id) {
        categoryMap[cat.parent_id]?.subcategories.push(categoryMap[cat.id]);
      } else {
        structuredCategories.push(categoryMap[cat.id]);
      }
    });
    return structuredCategories;
  };

  // Cart total
  useEffect(() => {
    const totalPrice = cartItems.reduce(
      (acc, item) => acc + item.price * item.qnty,
      0
    );
    setPrice(totalPrice);
  }, [cartItems]);

  const handleClick = (event) => setAnchorEl(event.currentTarget);
  const handleClose = () => setAnchorEl(null);
  const deleteItem = (id) => dispatch(DLT(id));

  // Login modal
  const handleOpen = () => setShowModal(true);
  const handleCloseModal = () => setShowModal(false);

  const dispatchs = useDispatch();

  const handleLoginSubmit = (e) => {
    e.preventDefault();
    const referrerPath = location.pathname;
    const userData = { email, password };
    dispatchs(loginCustomer(userData, navigate, setMessage, referrerPath));
    setShowModal(false);

    // after login, update state
    const savedUser = localStorage.getItem("webuser");
    if (savedUser) {
      setUser(JSON.parse(savedUser));
    }
  };

  useEffect(() => {
    if (message === "unauthorized") {
      Swal.fire({
        icon: "error",
        title: "Login",
        text: message,
      });
    } else if (message === "good") {
      Swal.fire({
        icon: "success",
        title: "Login",
        text: message,
      });
    }
  }, [message]);

  const handleLogout = () => {
    localStorage.removeItem("webuser");
    localStorage.removeItem("webuser_id");
    setUser(null);
    setDropdownOpen(false);
    navigate("/");
  };

  return (
    <>
      {/* Login Modal */}
      {showModal && (
        <div className="modal fade show d-block" tabIndex="-1" role="dialog">
          <div className="modal-dialog" role="document">
            <div className="modal-content">
              <div className="modal-header">
                <h5 className="modal-title">Login</h5>
              </div>
              <div className="modal-body">
                <form onSubmit={handleLoginSubmit}>
                  <div className="form-group mb-2">
                    <input
                      type="email"
                      className="form-control"
                      value={email}
                      onChange={(e) => setEmail(e.target.value)}
                      placeholder="Email"
                      required
                    />
                  </div>
                  <div className="form-group mb-2">
                    <input
                      type="password"
                      className="form-control"
                      value={password}
                      onChange={(e) => setPassword(e.target.value)}
                      placeholder="Password"
                      required
                    />
                  </div>
                </form>
              </div>
              <div className="modal-footer">
                <Button variant="secondary" onClick={handleCloseModal}>
                  Close
                </Button>
                <Button variant="primary" onClick={handleLoginSubmit}>
                  Login
                </Button>
              </div>
            </div>
          </div>
        </div>
      )}

      <header className="main-header style-two">
        {/* Top Bar */}
        <div className="header-top">
          <div className="container d-flex justify-content-between align-items-center">
            <ul className="info clearfix">
             <li><i className="flaticon-email"></i><a href="mailto:biofriend21@gmail.com">biofriend21@gmail.com</a></li>
                                    <li><i className="flaticon-phone-ringing"></i> +91-9560823297</li>
            </ul>

            <div className="auth d-flex align-items-center gap-3">
              {user ? (
                <div className="dropdown position-relative">
                  <span
                    className="dropdown-toggle"
                    onClick={() => setDropdownOpen(!dropdownOpen)}
                    style={{ cursor: "pointer" }}
                  >
                    Welcome {user}
                  </span>
                  {dropdownOpen && (
                    <div
                      className="dropdown-menu show"
                      style={{ position: "absolute", right: 0, top: "100%" }}
                    >
                      <NavLink
                        className="dropdown-item"
                        to="/myaccount"
                        onClick={() => setDropdownOpen(false)}
                      >
                        My Account
                      </NavLink>
                      <span
                        className="dropdown-item"
                        onClick={handleLogout}
                        style={{ cursor: "pointer" }}
                      >
                        Logout
                      </span>
                    </div>
                  )}
                </div>
              ) : (
                <Button
                  variant="link"
                  onClick={handleOpen}
                  style={{
                    backgroundColor: "rgb(229 9 127)",
                    textDecoration: "none",
                    padding: "3px 14px",
                    color: "#fff",
                  }}
                >
                  Login
                </Button>
              )}

              {/* Cart */}
              <Badge
                badgeContent={cartItems.length}
                color="success"
                onClick={handleClick}
                style={{ cursor: "pointer" }}
              >
                <i className="flaticon-shopping-cart-1"></i>
              </Badge>
              <Menu anchorEl={anchorEl} open={Boolean(anchorEl)} onClose={handleClose}>
                {cartItems.length ? (
                  <div style={{ width: "24rem", padding: "10px" }}>
                    <Table>
                      <thead>
                        <tr>
                          <th colSpan={2}>Product</th>
                        </tr>
                      </thead>
                      <tbody>
                        {cartItems.map((item) => (
                          <tr key={item.id}>
                            <td>
                              <NavLink
                                to={`/productdetails/${item.id}`}
                                onClick={handleClose}
                              >
                                <img
                                  src={
                                    item.images?.[0]
                                      ? `${BASE_URL}/public/uploads/products/${item.images[0]}`
                                      : "default.jpg"
                                  }
                                  alt={item.rname}
                                  style={{ width: "5rem", height: "5rem" }}
                                />
                              </NavLink>
                            </td>
                            <td>
                              <span>{item.rname}</span>
                              <br />
                              <span>Price: ₹{item.price}</span>
                              <br />
                              <span>Qty: {item.qnty}</span>
                            </td>
                            <td
                              onClick={() => deleteItem(item.id)}
                              style={{ cursor: "pointer", color: "red" }}
                            >
                              <i className="fas fa-trash"></i>
                            </td>
                          </tr>
                        ))}
                        <tr>
                          <td colSpan={3} className="text-center">
                            Total: ₹{price}
                          </td>
                        </tr>
                        <tr>
                          <td colSpan={3}>
                            <Button
                              as={Link}
                              to="/checkout"
                              variant="primary"
                              className="w-100"
                            >
                              Checkout
                            </Button>
                          </td>
                        </tr>
                      </tbody>
                    </Table>
                  </div>
                ) : (
                  <div className="text-center p-3">
                    <p>Your cart is empty</p>
                  </div>
                )}
              </Menu>
            </div>
          </div>
        </div>

        {/* Desktop Navbar */}
        <div className="header-lower">
          <div className="container d-flex justify-content-between align-items-center">
            <NavLink to="/" className="logo">
              <img
                src="assets_web/images/logo.png"
                alt="Logo"
                style={{ width: "80px" }}
              />
            </NavLink>

            <nav className="main-menu navbar-expand-md navbar-light d-none d-lg-block">
              <ul className="navigation clearfix d-flex list-unstyled gap-3 mb-0">
                <li>
                  <NavLink to="/" style={{ color: "#fff" }}>
                    Home
                  </NavLink>
                </li>
                <li>
                  <NavLink to="/about" style={{ color: "#fff" }}>
                    About
                  </NavLink>
                </li>
                <li>
                  <NavLink to="/products" style={{ color: "#fff" }}>
                    Products
                  </NavLink>
                </li>
                 <li>
                  <NavLink to="/WhyAnnpurna" style={{ color: "#fff" }}>
                    Why Annapurna
                  </NavLink>
                </li>
                <li>
                  <NavLink to="/contact-us" style={{ color: "#fff" }}>
                    Contact
                  </NavLink>
                </li>
              </ul>
            </nav>

            <div className="category-box pull-right text-white">
              <p>All Categories</p>
              <style>
                {`
                .category-row {
                  display: flex;
                  justify-content: space-between;
                  align-items: center;
                }

                .arrow {
                  font-size: 12px;
                  margin-left: 10px;
                }

                /* optional hover */
                .dropdown-option:hover .arrow {
                  transform: rotate(90deg);
                }

                  .category-content {
                    list-style: none;
                    padding: 0;
                    margin: 0;
                  }

                  .dropdown-option {
                    position: relative;
                    padding: 8px 12px;
                  }

                  .parent-label,
                  .parent-link {
                    font-weight: 600;
                    color: #000;
                    text-decoration: none;
                    cursor: pointer;
                  }

                  .submenu {
                    list-style: none;
                    padding-left: 15px;
                    display: none;
                  }

                  .dropdown-option:hover .submenu {
                    display: block;
                  }
                `}
            </style>
              <ul className="category-content">
                {categories.map((category) => (
                  <li key={category.id} className="dropdown-option">

                    <div className="category-row">
                      {/* Category name */}
                      {category.subcategories.length === 0 ? (
                        <a href={`/category/${category.id}`} className="parent-link">
                          {category.name}
                        </a>
                      ) : (
                        <span className="parent-label">{category.name}</span>
                      )}

                      {/* Arrow ONLY if submenu exists */}
                      {category.subcategories.length > 0 && (
                        <span className="arrow">▸</span>
                      )}
                    </div>

                    {/* Submenu */}
                    {category.subcategories.length > 0 && (
                      <ul className="submenu">
                        {category.subcategories.map((sub) => (
                          <li key={sub.id}>
                            <a href={`/category/${sub.id}`}>{sub.name}</a>
                          </li>
                        ))}
                      </ul>
                    )}
                  </li>
                ))}
              </ul>


            </div>

            {/* Mobile Hamburger */}
            <div className="d-block d-lg-none">
              <i
                className="fas fa-bars fa-lg"
                style={{ cursor: "pointer", color: "#fff" }}
                onClick={openOffcanvas}
              ></i>
            </div>
          </div>
        </div>

        {/* Mobile Offcanvas Menu */}
        <div
          className="offcanvas offcanvas-start"
          ref={offcanvasRef}
          tabIndex="-1"
        >
          <div className="main-menu offcanvas-body">
            <button className="btn-close mb-3" onClick={closeOffcanvas}></button>
            <ul className="mb-navigation">
              <li className="mb-2">
                <NavLink to="/" onClick={closeOffcanvas}>
                  Home
                </NavLink>
              </li>
              <li className="mb-2">
                <NavLink to="/about" onClick={closeOffcanvas}>
                  About
                </NavLink>
              </li>
              <li className="mb-2">
                <NavLink to="/products" onClick={closeOffcanvas}>
                  Products
                </NavLink>
              </li>
              <li className="mb-2">
                <NavLink to="/contact-us" onClick={closeOffcanvas}>
                  Contact
                </NavLink>
              </li>
            </ul>
          </div>
        </div>
      </header>
    </>
  );
}

export default Navbar;
